import { Box, Flex } from '@chakra-ui/react';
import { FC } from 'react';

interface IMessageBubble {
  content: string;
  myMessage: boolean;
}

export const MessageBubble: FC<IMessageBubble> = ({ content, myMessage }) => {
  if (myMessage) {
    return (
      <Flex justifyContent="flex-end">
        <Box maxW="85%" bg="violet.50" borderRadius="8px 8px 0px 8px" px={4} py={2}>
          {content}
        </Box>
      </Flex>
    );
  }

  return (
    <Flex justifyContent="flex-start">
      <Box maxW="85%" bg="gray.50" borderRadius="8px 8px 8px 0px" px={4} py={2}>
        {content}
      </Box>
    </Flex>
  );
};
